const SuspenseContent = () => {
    return (
      <div className="w-full h-screen flex justify-center items-center bg-transparent backdrop-blur-sm">
        <div className="flex items-center space-x-6">
          {/* Animated Loader with shadow */}
          <div className="w-20 h-20 border-8 border-t-transparent border-[#0F172A] border-solid rounded-full animate-spin-slow shadow-xl"></div>
          <div className="text-4xl font-bold text-black animate-pulse">
            <span>Loading...</span>
          </div>
        </div>
      </div>
    );
  };
  
  export default SuspenseContent;
  